<template>
  <ModalDialog
    ref="dialog"
    title="MYOB Query"
    icon="fa-search"
    :scrollable="false"
    @closed="onClosed"
    :showSubmit="false">

    <FormGroup v-bind:form="form" :labelColumnSize="2">
      <ContentTitle>Query MYOB</ContentTitle>

      <div>
        <FormRow label="Account">
          <FormStaticLabel>{{ accountName }}</FormStaticLabel>
        </FormRow>

        <FormRow label="Resource">
          <FormSelect :options="resourceNameLookup" v-model="queryInfo.resourceName" field="resourceName" />          
        </FormRow>
        <FormRow label="Field">
          <FormSelect :options="fieldNameLookup" v-model="queryInfo.fieldName" field="fieldName" />          
        </FormRow>
        <FormRow label="Search Text">
          <FormInputText v-model="queryInfo.searchValue" field="searchValue" placeholder="Search Text" />          
        </FormRow>

        <FormButton class="btn-primary" @click="searchMyobClicked" :loading="submitting"><i class="far fa-search" /> Search</FormButton>
      </div>
    </FormGroup>

    <div class="mt-3" v-if="searchResults">
      <ContentTitle>Results</ContentTitle>
      <div class="query-results">
        <pre>{{ searchResults }}</pre>
      </div>
    </div>
  </ModalDialog>
</template>

<style scoped>
.query-results {
  max-height: 300px;
  overflow: auto;
}
</style>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'DeveloperMyobQueryDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    accountId: Number,
    accountName: String
  },
  data() {
    return {
      queryInfo: {
        resourceName: 'Contact/Customer',
        fieldName: 'CompanyName',
        searchValue: ''
      },
      searchResults: '',
      form: {},
      submitting: false
    }
  },
  computed: {
    resourceNameLookup() {
      return [
        { value: 'Contact/Customer', name: 'Contact/Customer' },
        { value: 'Contact/Supplier', name: 'Contact/Supplier' },
        { value: 'Sale/Invoice/Service', name: 'Sale/Invoice/Service' },
        { value: 'Sale/CustomerPayment', name: 'Sale/CustomerPayment' },
        { value: 'Sale/CreditSettlement', name: 'Sale/CreditSettlement' },
      ]
    },
    fieldNameLookup() {
      if(this.queryInfo.resourceName === 'Contact/Customer' || this.queryInfo.resourceName === 'Contact/Supplier') {
        return [
          { value: 'CompanyName', name: 'Company Name' },
          { value: 'FirstName', name: 'First Name' },
          { value: 'LastName', name: 'Last Name' }
        ]
      }
      if(this.queryInfo.resourceName === 'Sale/Invoice/Service') {
        return [
          { value: 'Number', name: 'Number' }
        ]
      }
      if(this.queryInfo.resourceName === 'Sale/CustomerPayment') {
        return [
          { value: 'Customer/Name', name: 'Customer/Name' }
        ]
      }
      if(this.queryInfo.resourceName === 'Sale/CreditSettlement') {
        return [
          { value: 'Customer/Name', name: 'Customer/Name' }
        ]
      }

      return []
    }
  },
  watch: {
    'queryInfo.resourceName': function() {
      this.queryInfo.fieldName = ''
      if(this.fieldNameLookup.length > 0)
        this.queryInfo.fieldName = this.fieldNameLookup[0].value
    },
  },
  mounted() {
  },
  methods: {
    show() {
      this.form = {}
      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    searchMyobClicked() {
      this.submitting = true

      var queryInfo = {
        resourceName: this.queryInfo.resourceName,
        fieldName: this.queryInfo.fieldName,
        searchValue: this.queryInfo.searchValue
      }

      this.$apiService.developerService.developerGetMyobQuery(this.accountId, queryInfo)
        .then(response => {
          this.searchResults = JSON.stringify(response.data, null, 2)
        })
        .catch(err => {
          this.$data.form = this.processFormResponse(err)
        })
        .finally(() => {
          this.submitting = false
        })
    }
  }
}
</script>